import styled from "styled-components";

import { Box } from "../../../../../../components/Layout";

export const Container = styled.div``;

/* Inside the page's Box: without the side margins of a second one */
export const ThumbnailBox = styled(Box)`
  padding-top: 0;
  margin-right: 0;
  margin-left: 0;
`;
